import enCommon from './locales/en/common.json';
import enLayout from './locales/en/layout.json';
import enAuth from './locales/en/auth.json';
import enHome from './locales/en/home.json';
import enActivities from './locales/en/activities.json';
import enContests from './locales/en/contests.json';
import enGroups from './locales/en/groups.json';
import enTeams from './locales/en/teams.json';
import enProfile from './locales/en/profile.json';
import viCommon from './locales/vi/common.json';
import viLayout from './locales/vi/layout.json';
import viAuth from './locales/vi/auth.json';
import viHome from './locales/vi/home.json';
import viActivities from './locales/vi/activities.json';
import viContests from './locales/vi/contests.json';
import viGroups from './locales/vi/groups.json';
import viTeams from './locales/vi/teams.json';
import viProfile from './locales/vi/profile.json';

export const SUPPORTED_LANGUAGES = ['en', 'vi'] as const;
export type AppLanguage = typeof SUPPORTED_LANGUAGES[number];

// One namespace per feature area; English is the source of truth and the fallback.
export const resources = {
  en: {
    common: enCommon,
    layout: enLayout,
    auth: enAuth,
    home: enHome,
    activities: enActivities,
    contests: enContests,
    groups: enGroups,
    teams: enTeams,
    profile: enProfile,
  },
  vi: {
    common: viCommon,
    layout: viLayout,
    auth: viAuth,
    home: viHome,
    activities: viActivities,
    contests: viContests,
    groups: viGroups,
    teams: viTeams,
    profile: viProfile,
  },
} as const;
